import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Grid,
    Typography,
    TextField,
    Box,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Stack,
    Autocomplete,
    IconButton,
    Button,
    TextareaAutosize,
    Modal,
    Divider,
    FormControlLabel,
    Checkbox,
    FormLabel,
    FormGroup,
    Dialog, DialogContent,
} from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import { LoadingButton } from '@mui/lab';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import { styled } from '@mui/material/styles';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditIcon from '@mui/icons-material/Edit';
import ListIcon from '@mui/icons-material/List';
import { Icon } from '@iconify/react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useSnackbar } from 'notistack';
import ModalPopUp from '../../../components/Common/ModalPopUp';
import AppCache from '../../../services/AppCache';
import TextAreaWithToolbar from '../../../components/Common/TextAreaWithToolbar';
import URLS from '../../../services/urls.service';
import Iconify from '../../../components/Iconify';


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '100vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
const CustomPagination = (props) => <GridPagination {...props} />;
export default function IssueCreationDetailsPage() {

    const navigate = useNavigate();

    const issueCategoryColumn = [
        { field: 'SrNo', headerName: 'Sr.No', width: 80 },
        { field: 'Name', headerName: 'Name', flex: 0.5 },
        { field: 'Description', headerName: 'Description', flex: 1 }
    ];
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const userId = CurrentLoggedInUser?.ExecutiveId;

    const [pageSize, setPageSize] = useState(25);
    const { enqueueSnackbar } = useSnackbar();

    // Basic information
    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [site, setSite] = useState("");
    const [selectedSite, setSelectedSite] = useState([]);
    const [remark, setRemark] = useState("");
    const [openModal, setOpenModal] = useState("");
    const [clientRemark, setClientRemark] = useState("");
    const [siteRemark, setSiteRemark] = useState("");
    const [clientSiteRemark, setClientSiteRemark] = useState("");

    // Issue Details
    const [serviceDate, setServiceDate] = useState(new Date());
    const [ticketNo, setTicketNo] = useState("");
    const [medium, setMedium] = useState('');
    const [selectedMedium, setSelcetedMedium] = useState([]);
    const [priority, setPriority] = useState('');
    const [selectedPriority, setSelectedPriority] = useState([])
    const [reportedBy, setReportedBy] = useState(userId || '');
    const [selectedReportedBy, setSelectedReportedBy] = useState([]);
    const [ownedBy, setOwnedBy] = useState('');
    const [selectedOwnedBy, setSelectedOwnedBy] = useState([]);
    const [ccEmailId, setCCEmailId] = useState([]);   // keep as a single string
    const [apiEmail, setApiEmail] = useState([]);
    const [category, setCategory] = useState('');
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [division, setDivision] = useState('');
    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);
    const [requestFrom, setRequestFrom] = useState('');
    const [issueCtaegoryModal, setIssueCategoryModal] = useState(false);
    const [issueCategoryData, setissueCategoryData] = useState([]);
    const [availableSlotsData, setAvailableSlotsData] = useState([]);
    const [tentativeSupport, setTentativeSupport] = useState("");
    const [showTentativeSupport, setShowTentativeSupport] = useState(false);
    const [questionnaireModal, setQuestionnaireModal] = useState(false);
    const [questionnaireTxt, setQuestionnaireTxt] = useState("");
    const [questionnaire, setQuestionnaire] = useState("");
    const [selectedQuestionnaire, setSelectedQuestionnaire] = useState([]);
    const [error, setError] = useState("");
    const [executive, setExecutive] = useState(userId || "");
    const [defaultEmail, setDefaultEmail] = useState('');


    // Scheduling
    const [deliveryDate, setDeliveryDate] = useState(null);
    const [time, setTime] = useState("");
    const [timeError, setTimeError] = useState("");
    const [schedulingRemark, setSchedulingRemark] = useState('');
    const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
    const [appointmentDateTime, setAppointmentDateTime] = useState("");
    const [appointmentTime, setAppointmentTime] = useState("");
    const [requestFile, setRequestFile] = useState([]);
    const [pageSize1, setPageSize1] = useState(25);
    const [isCheck, setIsCheck] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");

    const [savedIssueId, setSavedIssueId] = useState(null);

    const [openModalForSaveIssue, setOpenModalForSaveIssue] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [copied, setCopied] = useState(false);
    const [serviceData, setServiceData] = useState([]);
    const fileInputRef = useRef(null);
    const [isLoading, setIsLoading] = useState();

    const availableSlotsDataColumn =
        availableSlotsData?.length > 0
            ? Object.keys(availableSlotsData[0]).map((key) => ({
                field: key,
                headerName: key === "SlotDate" ? "Date" : key.replace("_", "").replace("_", ":"),
                width: key === "SlotDate" ? 150 : 80,
                headerAlign: "center",
                align: "center",
            }))
            : [];

    const handleClient = (newValue) => {
        const clientId = newValue?.ClientId || 0;
        setClient(clientId);
        URLS.getServiceEntrySiteName({ ClientId: clientId })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        const payload = {
            "ClientId": clientId || 0,
            "SiteId": site || 0
        };
        URLS.getRemarks(payload)
            .then((res) => {
                console.log("remark>>>>>>>>>>>>>>>>>", res, res.data)
                const sections = res.data.remark.split("<;>");

                let clientText = "";
                let siteText = "";
                let clientSiteText = "";

                sections.forEach((part) => {
                    if (part.includes("Client+Site :-")) {
                        clientSiteText = part.replace("Client+Site :-", "").trim();
                    } else if (part.includes("Site :-")) {
                        siteText = part.replace("Site :-", "").trim();
                    } else if (part.includes("Client :-")) {
                        clientText = part.replace("Client :-", "").trim();
                    }
                });

                setClientRemark(clientText);
                setSiteRemark(siteText);
                setClientSiteRemark(clientSiteText);
                const combined =
                    (clientText ? `<b>Client :- ${clientText}</b><br/>` : "") +
                    (siteText ? `<b>Site :- ${siteText}</b><br/>` : "") +
                    (clientSiteText ? `<b>Client + Site :- ${clientSiteText}</b>` : "");

                setRemark(combined);
            })
            .catch(() => setApiEmail([]));
        // after fetching default values API
        URLS.getClientWiseDefaultValues({ ClientId: clientId })
            .then((res) => {
                const data = res.data;
                setMedium(Number(data.ReportingMediumId.value));
                setPriority(Number(data.PriorityId.value));
                setReportedBy(Number(data.ReportedById.value));
                setOwnedBy(Number(data.IssueOwnedById.value));

            });

    };
    console.log("default>>>>>>>>>>>>>>>>", priority)

    const handleSite = (newValue) => {
        const siteId = newValue?.SiteId || 0;
        setSite(siteId);
        const payload = {
            "ClientId": client || 0,
            "SiteId": siteId || 0
        };
        URLS.getRemarks(payload)
            .then((res) => {
                const sections = res.remark.split("<;>");

                let clientText = "";
                let siteText = "";
                let clientSiteText = "";

                sections.forEach((part) => {
                    if (part.includes("Client+Site :-")) {
                        clientSiteText = part.replace("Client+Site :-", "").trim();
                    } else if (part.includes("Site :-")) {
                        siteText = part.replace("Site :-", "").trim();
                    } else if (part.includes("Client :-")) {
                        clientText = part.replace("Client :-", "").trim();
                    }
                });

                setClientRemark(clientText);
                setSiteRemark(siteText);
                setClientSiteRemark(clientSiteText);
                const combined =
                    (clientText ? `<b>Client :- ${clientText}</b><br/>` : "") +
                    (siteText ? `<b>Site :- ${siteText}</b><br/>` : "") +
                    (clientSiteText ? `<b>Client + Site :- ${clientSiteText}</b>` : "");

                setRemark(combined);
            })
            .catch(() => setApiEmail([]));
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    }
    const handleClientRemark = (event) => {
        setClientRemark(event.target.value);
    };
    const handleSiteRemark = (event) => {
        setSiteRemark(event.target.value);
    };
    const handleClientSiteRemark = (e) => {
        setClientSiteRemark(e.target.value)
    };
    const handleEditClick = () => {
        setOpenModal(true);
    };

    const handleListClick = () => {
        // open past remarks or history
    };
    const handleServiceDate = (newValue) => {
        setServiceDate(newValue);
    };
    const handleTicketNo = (event) => {
        setTicketNo(event.target.value);
    };
    const handleMedium = (id) => {
        setMedium(id);
    }
    const handlePriority = (id) => {
        setPriority(id);
    };
    const handleReportedBy = (newValue) => {
        setReportedBy(newValue?.Id || "");

    };
    const handleOwnedBy = (newValue) => {
        setOwnedBy(newValue?.Id || "");
    };
    const handleInputChange = (event, value) => {
        if (value.length >= 3) {
            const payload = { Term: value };
            URLS.getEmail(payload)
                .then((res) => {
                    if (res.data && Array.isArray(res.data.data)) {
                        setApiEmail(res.data.data.map((item) => item.EmailId));
                    } else {
                        setApiEmail([]);
                    }
                })
                .catch(() => setApiEmail([]));
        } else {
            setApiEmail([]);
        }
    };

    const handleCategory = (newValue) => {
        setCategory(newValue?.Id || "");
    };
    const handeIssueCategoryOpenClick = () => {
        setIssueCategoryModal(true);
    };
    const handeIssueCategoryCancelClick = () => {
        setIssueCategoryModal(false);
    };
    const handleDivision = (event) => {
        setDivision(event.target.value);
    }
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const handleRequestFrom = (event) => {
        setRequestFrom(event.target.value);
    }
    const handleDeliveryDate = (newValue) => {
        setDeliveryDate(newValue);
    };
    const handleTime = (event) => {
        setTime(event.target.value);
    };
    const handleTimeBlur = () => {
        let value = time;

        if (/^\d:\d{2}$/.test(value)) value = `0${value}`;
        else if (/^\d$/.test(value)) value = `0${value}:00`;
        else if (/^\d{2}$/.test(value)) value += ":00";
        else if (/^\d{2}:$/.test(value)) return setTimeError("Invalid Time Format");

        const isValid = /^([01]?\d|2[0-3]):[0-5]\d$/.test(value);
        setTimeError(isValid ? "" : "Invalid Time Format");
        setTime(value);
    };

    const handleSchedulingRemark = (newValue) => {
        setSchedulingRemark(newValue);
    };
    const handleAppointemntOpenModal = () => {
        setOpenAppointmentModal(true);
    };
    const handleAppointemntCloseModal = () => {
        setOpenAppointmentModal(false);
    };
    const handleAppointmentDateTime = (newDate) => {
        setAppointmentDateTime(newDate); // Store as Date object

    };
    const handleAppointmentTime = (e) => {
        setAppointmentTime(e.target.value); // Time input uses "HH:mm"

    };
    const handleAppointmentSave = () => {
        if (!appointmentDateTime) {
            setError("Please select an appointment Date.");
            return;
        }
        if (!appointmentTime) {
            setError("Please select an appointment time.");
            return;
        }
        const selectedTime = Moment(appointmentTime, "hh:mm A");
        const selectedHour = selectedTime.hour();
        const selectedMinute = selectedTime.minute();

        const isValidTime =
            (selectedHour > 8 || (selectedHour === 8 && selectedMinute >= 30)) &&
            selectedHour < 18;

        if (!isValidTime) {
            setError("The appointment time is not in office hours.");
            return;
        }
        const formattedDate = Moment(appointmentDateTime).format("DD-MMM-YYYY"); // Extract date
        const formattedTime = Moment(appointmentTime, "hh:mm A").format("hh:mm A"); // Format time

        const mergedDateTime = `${formattedDate} ${formattedTime}`;
        const payload = {
            "AppointmentDateTime": mergedDateTime,
            "ExecutiveId": executive,
            "ClientId": "",
            "IssueCategoryID": "",
        };

        URLS.getAvailableSlots(payload)
            .then((response) => {
                const data = response.data;

                if (typeof data === "string") {
                    setOpenAppointmentModal(false);
                    setShowTentativeSupport(false);
                } else if (Array.isArray(data) && data.length > 0 && typeof data[0] === "object") {
                    setAvailableSlotsData(data);
                    setShowTentativeSupport(true);
                }
            })
            .catch(error => {
                console.log("Error fetching available slots", error);
            });
        setSelectedDate(mergedDateTime); // Save valid date

    }

    const handleStatusRemarkSave = () => {
        setOpenModal(false);
        const payload = {
            "SiteId": site || "",
            "ClientId": client || "",
            "SiteRemark": siteRemark || "",
            "ClientRemark": clientRemark || "",
            "CommonRemark": clientSiteRemark || ""
        }

        URLS.updateRemark(payload)
            .then((response) => {
                enqueueSnackbar("Remark Saved Successfully. ", { variant: 'success' });

            }).catch(error => {
                enqueueSnackbar("Remark Not Saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    }
    const handleQuestionnaireOpenClick = () => {
        setQuestionnaireModal(true);
        URLS.getAppointmentDateQuestionnaire()
            .then((response) => {
                const data = response.data[0];
                setQuestionnaireTxt(response.data[0].Questionnaire)
                console.log("data>>>>>>>>>>>>>>>>>>", data, response.data[0].Questionnaire)
                setSelectedQuestionnaire(response.data[0].DataValues)
            })
            .catch(error => {
                console.log("Error in loadIssueRCAData:", error);
            });
    }
    const handelQuestionnaireCancelClick = () => {
        setQuestionnaireModal(false);
    };
    const handleQuestionnaire = (event) => {
        setQuestionnaire(event.target.value)
    }
    const handleTentativeSupport = () => {
        URLS.getTentativeSupport()
            .then((response) => {

                setTentativeSupport(response.data || [])
                setExecutive(response.data);
                setOpenAppointmentModal(false);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }
    const handleCheckbox = (event) => {
        setIsCheck(event.target.checked);
    };
    const handleSelectFile = (event) => {
        const selectedFiles = Array.from(event.target.files);

        console.log("selectedFiles", selectedFiles)
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result; // Base64 string with data type prefix
                setRequestFile((prev) => [
                    ...prev,
                    {
                        file, // Original File object
                        name: file.name,
                        type: file.type,
                        base64: base64Data, // Base64 string
                    },
                ]);
            };
            reader.readAsDataURL(file); // Convert to base64
        });

        event.target.value = ""; // Clear the file input
    };
    console.log("selectedafile>>>>>>>>>>>>>>>>>>", requestFile)
    const removeFile = (index) => {
        setRequestFile((prevFiles) => prevFiles.filter((_, i) => i !== index)); // Remove file by index
    };
    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        setRequestFile((prev) => [...prev, ...droppedFiles]);
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // allows drop
    };

    const handleDrgaDropClick = () => {
        fileInputRef.current.click();
    };
    const validateIssueForm = () => {
        if (!client) {
            enqueueSnackbar("Please select a Client.");
            return false;
        }
        if (!site) {
            enqueueSnackbar("Please select a Site.");
            return false;
        }
        if (!serviceDate) {
            enqueueSnackbar("Please select a Date.");
            return false;
        }
        if (!medium) {
            enqueueSnackbar("Please select a Medium.");
            return false;
        }
        if (!priority) {
            enqueueSnackbar("Please select a Priority.");
            return false;
        }
        if (!reportedBy) {
            enqueueSnackbar("Please select a Reported By.");
            return false;
        }
        if (!ownedBy) {
            enqueueSnackbar("Please select a Owned By.");
            return false;
        }
        if (!category) {
            enqueueSnackbar("Please select a Issue Category.");
            return false;
        }
        if (!division) {
            enqueueSnackbar("Please select a Division.");
            return false;
        }
        if (!project) {
            enqueueSnackbar("Please select a Project Version.");
            return false;
        }
        if (!schedulingRemark) {
            enqueueSnackbar("Please select a Remark.");
            return false;
        }
        return true;
    };

    const handleIssueSave = () => {
        setIsLoading(true);
        const payload = {
            "ClientId": client,
            "SiteId": site,
            "IssueId": 0,
            "ReportingMediumId": medium || 0,
            "LoginId": userId,
            "IssueCreationDate": serviceDate ? Moment(serviceDate).format("DD-MMM-YYYY") : "",
            "IssueOwnedById": ownedBy,
            "ReportedById": reportedBy,
            "IssueCategoryId": category,
            "PriorityId": priority,
            "SubStatusId": 0,
            "ProjectVersionId": project || 0,
            "AppointmentDatePart": appointmentDateTime ? Moment(appointmentDateTime).format("DD-MMM-YYYY") : "",
            "AppointmentTimePart": appointmentTime ? Moment(appointmentTime, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "DeliveryDatePart": deliveryDate ? Moment(deliveryDate).format("DD-MMM-YYYY") : "",
            "DeliveryTimePart": time ? Moment(time, ["HH:mm", "h:mm A", "HH:mm:ss"]).format("HH:mm") : "",
            "Date": serviceDate ? Moment(serviceDate).format("DD-MMM-YYYY") : "",
            "CCEmailId": Array.isArray(ccEmailId) ? ccEmailId.join(", ") : "",
            "DefultEmailId": defaultEmail || "",
            "TicketNo": ticketNo,
            "Remarks": schedulingRemark || "",
            "Division": division,
            "RequestFrom": requestFrom,
            "LastRemarks": "",
            "IsCallListIssue": isCheck || true,
            "ExcludeFromDashboard": true,
            "ExpectedTime": 0,
            "ChildIssueId": 0,
            "FileName": "",
            "Status": false || 0,
            "Files": requestFile.map((f) => ({
                FileBase64: f.base64,
                FileName: f.name,
            })),
            "IsChildIssueNew": false,
            "ParentIssueId": 0
        }
        console.log("payload>>>>>>>>>", payload, appointmentDateTime)
        URLS.createNewIssue(payload)
            .then((response) => {
                if (response.status === 200) {
                    console.log("response", response, response.data)
                    const values = Object.values(response.data);
                    const message = values[1]; // second property: "Issue with Id 503341..."

                    const match = message.match(/Id\s+(\d+)/i);
                    if (match) {
                        const issueId = match[1]; // "503341"
                        setSavedIssueId(issueId);

                    }

                    // handleReset();
                    setOpenSuccess(true);
                    setIsSaved(true);
                    setIsLoading(false);

                }

            }).catch(error => {
                setIsLoading(false);
                const errorMsg = error?.response?.data?.msg || "Record not saved.";
                enqueueSnackbar(errorMsg, { variant: 'error' });

            });

    }
    const handleReset = () => {
        setClient("");
        setSite("");
        setClientRemark("");
        setSiteRemark("");
        setClientSiteRemark("");
        setServiceDate(new Date());
        setTicketNo("");
        setMedium("");
        setPriority("");
        setReportedBy(userId || "");
        setOwnedBy("");
        setCCEmailId("");
        setCategory("");
        setIssueCategoryModal(false);
        setDivision("");
        setProject("");
        setRequestFrom("");
        setDeliveryDate(null);
        setTime("");
        setTimeError("");
        setSchedulingRemark("");
        setIsCheck(false);
        setRequestFile([]);
        setOpenAppointmentModal(false);
        setIsSaved(false);
    }
    const handleSaveIssueClick = () => {
        if (validateIssueForm()) {
            setOpenModalForSaveIssue(true);
        }
    };

    const handleSaveIssueConfirm = (value) => {
        if (value) {
            handleIssueSave();
        }
        setOpenModalForSaveIssue(false);
    };
    const handleCopyId = () => {
        if (savedIssueId) {
            navigator.clipboard.writeText(savedIssueId);
            setCopied(true);

            // reset after 2 seconds
            setTimeout(() => setCopied(false), 2000);
        }
    };
    const handleFillService = () => {
        if (!savedIssueId) return;
        const payload = {
            "ClientIdList": [0],
            "SiteIdList": [0],
            "ExecutiveID": 0,
            "ContactPersonId": 0,
            "frmDate": "",
            "toDate": "",
            "Status": 2,
            "IssueOwnedById": "",
            "Date": 0,
            "OrderBy": "",
            "IncludeChilren": 0,
            "PriorityId": 0,
            "SubStatusIdList": [0],
            "IssueCategoryIdList": [0],
            "IssueId": Number(savedIssueId),
            "ProjectIdList": [0],
            "IssueCreatededById": 0
        };
        URLS.loadService(payload)
            .then((res) => {
                if (Array.isArray(res.data) && res.data.length > 0) {
                    const rowData = res.data[0];

                    navigate('/dashboard/servicedetailspage', { state: { loadData: rowData } });
                } else {
                    enqueueSnackbar("No service data found", { variant: "error" });
                }
            })
            .catch(() => {
                enqueueSnackbar("Failed to load service details", { variant: "error" });
            });
    };


    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        URLS.loadPriority()
            .then((response) => {
                setSelectedPriority(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives()
            .then((response) => {
                setSelectedReportedBy(response.data);
                setSelectedOwnedBy(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadIssueCategory()
            .then((response) => {
                setSelectedCategory(response.data);
                setissueCategoryData(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        // URLS.projectList()
        URLS.getServiceEntryProject()

            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getReportingMediumdata()
            .then((response) => {
                setSelcetedMedium(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getDefaultEmailId({ UserId: userId })
            .then((response) => {
                const defaultEmail = Array.isArray(response.data) && response.data.length > 0
                    ? response.data[0].EmailId || ""
                    : "";

                setDefaultEmail(defaultEmail)
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);

    useEffect(() => {
        URLS.getDefaultEmailId({ UserId: reportedBy })
            .then((response) => {
                const defaultEmail = Array.isArray(response.data) && response.data.length > 0
                    ? response.data[0].EmailId || ""
                    : "";
                setDefaultEmail(defaultEmail);
            })
            .catch(() => console.log("Error"));
    }, [reportedBy]);

    return (
        <>
            <Grid container rowSpacing={1}        // vertical gap (Y-axis)
                columnSpacing={2.5} mx={0} mt={0.2} sx={{ overflowX: "hidden", margin: 0, width: "100%", }} >
                {/* Left Side - 50% */}
                <Grid item xs={12} sm={5.9}>
                    <Box
                        sx={{
                            height: '75vh',
                            display: 'flex',
                            flexDirection: 'column',
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            overflow: 'hidden', // hide scrollbars from main box
                            backgroundColor: '#FFFFFF',

                        }}
                    >
                        {/* ====== Basic Information Section ====== */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10,
                                    backgroundColor: '#FFFFFF',
                                    px: 2,
                                    pt: 1.5,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <AssignmentOutlinedIcon sx={{ color: '#4A5565', mr: 1, width: 20, height: 20, }} />
                                    <Typography variant="h5">Basic Information</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ px: 2, pb: 2 }}>

                                <Grid container columnSpacing={2} rowSpacing={0}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth size="small">
                                            <FormLabel sx={{
                                                mb: 0.5,
                                                '&::after': {
                                                    content: '" *"',
                                                    color: 'red',
                                                },
                                            }}
                                            >
                                                Client
                                            </FormLabel>

                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                id="client"
                                                value={selectedClient.find((item) => item.ClientId === client) || null}
                                                onChange={(_, newValue) => handleClient(newValue)}
                                                options={selectedClient}
                                                getOptionLabel={(option) => option.Name || ""}
                                                isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.ClientId}>
                                                        {option.Name}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Client"
                                                        variant="outlined"
                                                    />
                                                )}

                                            />
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl
                                            size="small"
                                            fullWidth
                                        >
                                            <FormLabel sx={{
                                                mb: 0.5,
                                                '&::after': {
                                                    content: '" *"',
                                                    color: 'red',
                                                },
                                            }}>
                                                Site
                                            </FormLabel>
                                            <Autocomplete

                                                fullWidth
                                                size="small"
                                                id="site"
                                                value={selectedSite.find((item) => item.SiteId === site) || null}
                                                onChange={(_, newValue) => handleSite(newValue)}
                                                options={selectedSite}
                                                getOptionLabel={(option) => option.Name || ""}
                                                isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select Site"
                                                        variant="outlined"
                                                    />
                                                )}


                                            />

                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>

                                        <Box >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    mb: '-17px',
                                                }}
                                            >
                                                <FormLabel sx={{ mb: 0.5 }}>Client remark / Site remark / Client-Site remark </FormLabel>

                                                <Box>
                                                    <IconButton size="small" color="primary" onClick={handleEditClick}>
                                                        <ModeEditOutlineOutlinedIcon sx={{ fontSize: 16 }} />

                                                    </IconButton>
                                                    <IconButton size="small" color="primary" onClick={handleListClick}>
                                                        <ReorderOutlinedIcon sx={{ fontSize: 16 }} />
                                                    </IconButton>
                                                </Box>


                                            </Box>
                                        </Box>
                                        <Modal open={openModal} onClose={handleCloseModal}>
                                            <Box
                                                sx={modalStyle}

                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '10px 16px',
                                                        borderBottom: '1px solid #E0E0E0',
                                                        backgroundColor: '#fff',
                                                        m: 0, // remove outer margins
                                                    }}
                                                >
                                                    <Typography variant="h5" fontWeight="bold">Remark</Typography>
                                                    <IconButton onClick={handleCloseModal}>
                                                        <Icon icon="mdi:close" />
                                                    </IconButton>
                                                </Box>

                                                <Box sx={{ px: 2, pt: 2 }}>
                                                    <Stack spacing={1.5}>
                                                        {/* Client Remark */}
                                                        <FormControl size="small" fullWidth>
                                                            <FormLabel>Client remark </FormLabel>
                                                            <TextareaAutosize
                                                                minRows={3}
                                                                placeholder="Enter detailed client remarks about the issue..."
                                                                value={clientRemark}
                                                                onChange={handleClientRemark}
                                                                style={{ overflow: 'auto', }}
                                                            />
                                                        </FormControl>
                                                        {/* Site Remark */}
                                                        <FormControl size="small" fullWidth>
                                                            <FormLabel>Site remark </FormLabel>
                                                            <TextareaAutosize
                                                                minRows={3}
                                                                placeholder="Enter detailed site remarks about the issue..."
                                                                value={siteRemark}
                                                                onChange={handleSiteRemark}
                                                                style={{ overflow: 'auto', }}

                                                            />
                                                        </FormControl>

                                                        {/* Client + Site Remark */}
                                                        <FormControl size="small" fullWidth>
                                                            <FormLabel>Client - Site remark </FormLabel>
                                                            <TextareaAutosize
                                                                minRows={3}
                                                                placeholder="Enter detailed client - site remarks about the issue..."
                                                                value={clientSiteRemark}
                                                                onChange={handleClientSiteRemark}
                                                                style={{ overflow: 'auto', }}

                                                            />
                                                        </FormControl>

                                                    </Stack>
                                                </Box>
                                                {/* Save and Cancel Buttons */}
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        gap: 1.5,
                                                        px: 2,
                                                        py: 1.5,

                                                        mt: 2,
                                                    }}
                                                >
                                                    <Button
                                                        size="medium"
                                                        type="submit"
                                                        variant="contained"
                                                        sx={{ color: "white" }}
                                                        onClick={handleStatusRemarkSave}
                                                    >
                                                        Save
                                                    </Button>

                                                </Box>
                                            </Box>
                                        </Modal>

                                    </Grid>

                                </Grid>

                                <Divider sx={{ borderColor: "#EBEBEB", mt: 2, mb: 1 }} />

                                <Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <InfoOutlinedIcon sx={{ color: '#4A5565', mr: 1, width: 20, height: 20, }} />
                                        <Typography variant="h5">Issue Details</Typography>
                                    </Box>
                                    <Grid container columnSpacing={2} rowSpacing={1}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl fullWidth size="small">
                                                <FormLabel
                                                    sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                >
                                                    Select Date
                                                </FormLabel>

                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MMM/yyyy"
                                                        value={serviceDate}
                                                        onChange={handleServiceDate}
                                                        disableFuture
                                                        renderInput={(params) => <TextField size="small" fullWidth {...params} error={false} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{ mb: 0.5 }}>Ticket No.</FormLabel>
                                                <TextField fullWidth size="small" value={ticketNo} onChange={handleTicketNo} placeholder="Enter ticket number" />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel
                                                    sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                >
                                                    Medium
                                                </FormLabel>
                                                <Select
                                                    size="small"
                                                    value={medium}
                                                    displayEmpty
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return <span style={{ color: '#928A8A' }}>Select Medium</span>;
                                                        }
                                                        return selectedMedium.find((m) => m.Id === selected)?.Name;
                                                    }}

                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                                width: '200px',
                                                            },
                                                        },
                                                    }}

                                                >
                                                    <MenuItem value="" onClick={() => handleMedium()} >Select Medium</MenuItem>

                                                    {selectedMedium.map((medium) => (
                                                        <MenuItem key={medium.Id} value={medium.Id} onClick={() => handleMedium(medium.Id)}>
                                                            {medium.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel
                                                    sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                >
                                                    Priority
                                                </FormLabel>
                                                <Select
                                                    size="small"
                                                    value={priority}
                                                    displayEmpty
                                                    renderValue={(selected) => {
                                                        if (!selected) {
                                                            return <span style={{ color: '#928A8A' }}>Select Priority</span>;
                                                        }
                                                        return selectedPriority.find((m) => m.Id === selected)?.Name;
                                                    }}

                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                                width: '200px',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="" onClick={() => handlePriority()}>Select Priority</MenuItem>
                                                    {selectedPriority.map((priority) => (
                                                        <MenuItem key={priority.Id} value={priority.Id} onClick={() => handlePriority(priority.Id)}>
                                                            {priority.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel
                                                    sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                >
                                                    Reported By
                                                </FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    value={selectedReportedBy.find((item) => item.Id === reportedBy) || null}
                                                    onChange={(_, newValue) => handleReportedBy(newValue)}
                                                    options={selectedReportedBy}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option.Id}>
                                                            {option.Name}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} placeholder="Enter reporter name" />}

                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>

                                                <FormLabel
                                                    sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                >
                                                    Owned By
                                                </FormLabel>

                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    value={selectedOwnedBy.find((item) => item.Id === ownedBy) || null}
                                                    onChange={(_, newValue) => handleOwnedBy(newValue)}
                                                    options={selectedOwnedBy}
                                                    getOptionLabel={(option) => option.Name || ""}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option.Id}>
                                                            {option.Name}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} placeholder="Enter owner name" />}

                                                />
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

                                                    <Typography
                                                        sx={{ color: 'text.secondary', fontSize: 10, fontWeight: 500 }}
                                                    >
                                                        Default Emails -{" "}
                                                        <Box
                                                            component="span"
                                                            sx={{ color: '#155DFC', textDecoration: 'underline' }}
                                                        >
                                                            {defaultEmail}
                                                        </Box>
                                                    </Typography>
                                                </Box>

                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControl size="small" fullWidth>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <FormLabel sx={{
                                                            mb: 0.5,
                                                            '&::after': {
                                                                content: '" *"',
                                                                color: 'red',
                                                            },
                                                        }}>
                                                            Issue Category
                                                        </FormLabel>
                                                        <IconButton
                                                            size="small"
                                                            onClick={handeIssueCategoryOpenClick}
                                                            sx={{ color: '#99A1AF', width: '15px', height: '15px', p: 0 }}
                                                        >
                                                            <HelpOutlineIcon sx={{ fontSize: '15px' }} />
                                                        </IconButton>
                                                    </Box>

                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        value={selectedCategory.find((item) => item.Id === category) || null}
                                                        onChange={(_, newValue) => handleCategory(newValue)}
                                                        options={selectedCategory}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.Id}>
                                                                {option.Name}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => <TextField {...params} placeholder="Issue Category" />}

                                                    />
                                                </FormControl>

                                                <Modal open={issueCtaegoryModal} onClose={handeIssueCategoryCancelClick}>
                                                    <Box sx={style}>

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h5" fontWeight='bold'>
                                                                Issue Category
                                                            </Typography>

                                                            <IconButton
                                                                onClick={handeIssueCategoryCancelClick}
                                                                sx={{
                                                                    color: 'grey',
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Box>

                                                        <div style={{ height: '62vh', width: '100%' }}>
                                                            <DataGrid
                                                                rows={issueCategoryData}
                                                                columns={issueCategoryColumn}
                                                                density="compact"
                                                                getRowId={(row) => row.id || issueCategoryData.indexOf(row)}
                                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                pagination
                                                                paginationMode="client"
                                                                rowsPerPageOptions={[25, 50, 100]}
                                                                pageSize={pageSize}
                                                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                                            />
                                                        </div>
                                                    </Box>
                                                </Modal>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6} >
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{
                                                    mb: 0.5,
                                                    '&::after': {
                                                        content: '" *"',
                                                        color: 'red',
                                                    },
                                                }}>Project Version</FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    id="project Version"
                                                    value={selectedProject.find((item) => item.ProjectVersionId === project) || null}
                                                    onChange={(_, newValue) => handleProject(newValue)}
                                                    options={selectedProject}
                                                    getOptionLabel={(option) => option.ProjectVersionName || ""}
                                                    isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option.ProjectVersionId}>
                                                            {option.ProjectVersionName}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} placeholder="Enter Project" />}

                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{ mb: 0.5 }}>CC Email ID</FormLabel>
                                                <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    multiple
                                                    freeSolo
                                                    options={apiEmail}
                                                    value={ccEmailId}
                                                    onChange={(_, newValue) => setCCEmailId(newValue)}
                                                    onInputChange={handleInputChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={!ccEmailId.length && "Enter email addresses (comma separated)"}
                                                        />
                                                    )}
                                                    renderTags={(value) => (
                                                        <Box
                                                            sx={{
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                overflowWrap: "anywhere",
                                                            }}
                                                        >
                                                            {value.join(", ")}
                                                        </Box>
                                                    )}

                                                />

                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{
                                                    mb: 0.5,
                                                    '&::after': {
                                                        content: '" *"',
                                                        color: 'red',
                                                    },
                                                }}>Division / Franchise</FormLabel>
                                                <TextField fullWidth size="small" value={division} onChange={handleDivision} placeholder="Enter division or franchise" />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{ mb: 0.5 }}>Request From</FormLabel>

                                                <TextField fullWidth size="small" value={requestFrom} onChange={handleRequestFrom} placeholder="Enter request from" />
                                            </FormControl>

                                        </Grid>


                                    </Grid>

                                </Box>

                            </Box>
                        </Box>
                    </Box>

                </Grid>

                <Grid item xs={12} sm={5.9}>
                    <Box
                        sx={{
                            height: '75vh',
                            display: 'flex',
                            flexDirection: 'column',
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            overflow: 'hidden', // hide scrollbars from main box
                            backgroundColor: '#FFFFFF',

                        }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10,
                                    backgroundColor: '#FFFFFF',
                                    px: 2,
                                    pt: 1.5,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: '-10px' }}>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Icon icon="material-symbols:problem-outline-rounded" style={{ width: 20, height: 20, marginRight: 8 }} />
                                        <Typography variant="h5" sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Issue Reported</Typography>

                                    </Box>

                                </Box>
                            </Box>
                            <Box sx={{ px: 2, pb: 2, }}>

                                <TextAreaWithToolbar
                                    value={schedulingRemark}
                                    onChange={handleSchedulingRemark}
                                    placeholder="Enter detailed remarks about the issue..."
                                    toolbarId="toolbar1"
                                    isEditable="true"
                                    minHeight={116}
                                />

                                <Divider sx={{ borderColor: "#EBEBEB", mb: 1 }} />

                                <Box sx={{ mb: 1 }}>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between', // left & right alignment
                                            alignItems: 'center',
                                            mb: 1,
                                        }}
                                    >

                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Icon icon="mdi:calendar-clock-outline" style={{ width: 20, height: 20, marginRight: 8 }} />
                                            <Typography variant="h5">Scheduling</Typography>

                                        </Box>

                                        <Button
                                            onClick={handleAppointemntOpenModal}
                                            size="medium"
                                            variant="contained"
                                            color="secondary"
                                            startIcon={
                                                <Icon
                                                    icon="material-symbols:pace"
                                                    style={{ fontSize: 14 }}
                                                />
                                            }
                                            sx={{ p: 1, fontSize: 12, height: 28 }}
                                        >
                                            {selectedDate
                                                ? Moment(selectedDate).format("DD-MMM-YYYY hh:mm A")
                                                : "Set Appointment"}
                                        </Button>

                                        <Modal open={openAppointmentModal} onClose={handleAppointemntCloseModal}>
                                            <Box sx={style}>

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '10px 16px',
                                                        borderBottom: '1px solid #E0E0E0',
                                                        backgroundColor: '#fff',
                                                        m: 0, // remove outer margins
                                                    }}
                                                >
                                                    <Typography variant="h5" fontWeight='bold'>
                                                        Set Appointment
                                                    </Typography>

                                                    <IconButton
                                                        onClick={handleAppointemntCloseModal}
                                                        sx={{
                                                            color: 'grey',
                                                        }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Box>
                                                <Stack spacing={3} sx={{ p: 2 }}>
                                                    <Stack
                                                        direction="row"
                                                        spacing={2}
                                                        alignItems="flex-end"
                                                        justifyContent="space-between"
                                                        flexWrap="wrap"
                                                    >
                                                        <FormControl sx={{ flex: 1 }} size="small">
                                                            <FormLabel>Appointment Date</FormLabel>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DesktopDatePicker
                                                                    inputFormat="dd/MMM/yyyy"
                                                                    value={Moment(appointmentDateTime, 'DD-MMM-YYYY').toDate()}
                                                                    onChange={handleAppointmentDateTime}
                                                                    renderInput={(params) => (
                                                                        <TextField fullWidth size="small" {...params} error={false} />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>

                                                        {/* Time */}
                                                        <FormControl sx={{ flex: 1 }} size="small">
                                                            <FormLabel>Appointment Time</FormLabel>
                                                            <TextField
                                                                value={appointmentTime ? Moment(appointmentTime, 'hh:mm A').format('HH:mm') : ''}
                                                                onChange={handleAppointmentTime}
                                                                type="time"
                                                                InputLabelProps={{ shrink: true }}
                                                                inputProps={{ step: 300 }}
                                                                size="small"
                                                                fullWidth
                                                            />

                                                        </FormControl>
                                                        <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                                                            <Button
                                                                size="medium"
                                                                variant="contained"
                                                                sx={{ color: "white" }}
                                                                onClick={handleAppointmentSave}
                                                            >
                                                                Save
                                                            </Button>
                                                            {showTentativeSupport && (
                                                                <Button
                                                                    size="medium"
                                                                    variant="contained"
                                                                    sx={{ color: "white", height: 40 }}
                                                                    onClick={handleTentativeSupport}
                                                                >
                                                                    Tentative Support
                                                                </Button>
                                                            )}
                                                        </Stack>
                                                    </Stack>
                                                    {error && (
                                                        <Typography color="error" variant="body2">
                                                            {error}
                                                        </Typography>
                                                    )}
                                                    {showTentativeSupport && (

                                                        <Stack direction="row" spacing={2} alignItems="center">
                                                            <div style={{ height: '60vh', width: '100%' }}>
                                                                <DataGrid
                                                                    rows={availableSlotsData}
                                                                    columns={availableSlotsDataColumn}
                                                                    density="compact"
                                                                    getRowId={(row) => row.SlotDate}
                                                                    components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                    pagination
                                                                    paginationMode="client"
                                                                    rowsPerPageOptions={[25, 50, 100]}
                                                                    pageSize={pageSize1}
                                                                    onPageSizeChange={(newPageSize) => setPageSize1(newPageSize)}
                                                                    getRowHeight={() => 'auto'}
                                                                    sx={{

                                                                        '& .MuiDataGrid-iconSeparator': {
                                                                            display: "none", // Removes the separator
                                                                        },
                                                                        '& .MuiDataGrid-row:nth-of-type(even)': {
                                                                            backgroundColor: 'white', // Even rows: White
                                                                        },
                                                                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                                            backgroundColor: '#f5f3f2', // Odd rows: Blue
                                                                            color: 'bleck', // Set text color to white for better contrast
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        </Stack>
                                                    )}

                                                </Stack>
                                            </Box>
                                        </Modal>

                                        <Modal open={questionnaireModal} onClose={handelQuestionnaireCancelClick}>
                                            <Box sx={modalStyle}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '10px 16px',
                                                        borderBottom: '1px solid #E0E0E0',
                                                        backgroundColor: '#fff',
                                                        m: 0, // remove outer margins
                                                    }}
                                                >
                                                    <IconButton
                                                        onClick={handelQuestionnaireCancelClick}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            right: '10px',
                                                            color: 'grey',
                                                        }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                    <Typography variant="h5" color="#E7000B" mb={1}>
                                                        Appointment Date Change Reason
                                                    </Typography>
                                                </Box>

                                                <Stack spacing={3}>
                                                    <Stack direction="row" spacing={2} mt={4}>

                                                        <Typography variant="h5" mb={1}>
                                                            {questionnaireTxt}
                                                        </Typography>

                                                        <FormControl size="small" fullWidth>
                                                            <Select
                                                                size="small"
                                                                value={questionnaire} // This value should match the selected option
                                                                onChange={handleQuestionnaire} // Use the onChange directly to set the value
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        sx: {
                                                                            backgroundColor: '#fbe9e7',
                                                                            maxHeight: '200px',
                                                                            width: '200px', // Set the max height here
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                {selectedQuestionnaire.map((reason) => (
                                                                    <MenuItem key={reason.Id} value={reason.Id}> {/* Removed onClick */}
                                                                        {reason.Value}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>

                                                    {/* Save and Cancel Buttons */}
                                                    <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
                                                        <Button
                                                            size="medium"
                                                            type="submit"
                                                            variant="contained"
                                                            sx={{ color: "white" }}
                                                            onClick={handelQuestionnaireCancelClick}
                                                        >
                                                            Save
                                                        </Button>

                                                    </Stack>
                                                </Stack>
                                            </Box>
                                        </Modal>
                                    </Box>

                                    <Grid container columnSpacing={2} rowSpacing={1}>

                                        <Grid item xs={12} sm={6}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{ mb: 0.5 }}>Delivery Date</FormLabel>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MMM/yyyy"
                                                        value={deliveryDate}
                                                        onChange={handleDeliveryDate}
                                                        renderInput={(params) => <TextField size="small" fullWidth {...params} error={false} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl size="small" fullWidth>
                                                <FormLabel sx={{ mb: 0.5 }}>Time</FormLabel>
                                                <TextField
                                                    size="small"
                                                    type="text"
                                                    value={time}
                                                    onChange={handleTime}
                                                    onBlur={handleTimeBlur}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={{ maxLength: 5 }}
                                                    placeholder="HH:MM"
                                                    error={!!timeError}
                                                    helperText={timeError}
                                                />

                                            </FormControl>

                                        </Grid>

                                    </Grid>
                                </Box>
                                <Divider sx={{ borderColor: "#EBEBEB", mb: 1 }} />

                                {/* Header */}
                                <Box sx={{ display: "flex", alignItems: "center", }}>
                                    <SettingsOutlinedIcon sx={{ color: "#4A5565", mr: 1, width: 20, height: 20, }} />
                                    <Typography variant="h5" fontWeight={500}>
                                        Additional Option
                                    </Typography>
                                </Box>

                                {/* Checkbox */}
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isCheck}
                                                onChange={handleCheckbox}
                                                icon={
                                                    <Box
                                                        sx={{
                                                            width: 18,
                                                            height: 18,
                                                            border: '1px solid #D1D5DB',
                                                            borderRadius: '4px',
                                                        }}
                                                    />
                                                }
                                                checkedIcon={
                                                    <Box
                                                        sx={{
                                                            width: 18,
                                                            height: 18,
                                                            border: '1px solid #D1D5DB',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#1976d2',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: '#fff',
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        ✓
                                                    </Box>
                                                }
                                            />
                                        }
                                        label="Include this issue in call list"
                                    />
                                </FormGroup>

                                {/* Before Upload: First Image Style */}
                                {requestFile.length === 0 ? (
                                    <Box
                                        component="label"
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        onClick={handleDrgaDropClick}
                                        sx={{
                                            border: '2px solid transparent',

                                            // Use the borderImageSource with an SVG to create the custom dash pattern.
                                            borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                            borderImageSlice: '1',
                                            minHeight: "127px",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#757575",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                border: "1px solid #ddd",
                                                borderRadius: 2,
                                                backgroundColor: "#fff",
                                                p: 1.5,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mb: 1,
                                                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)"
                                            }}
                                        >
                                            <Iconify
                                                icon="material-symbols:add-notes-outline-rounded"
                                                width={40}
                                                height={40}
                                                style={{ color: "#1a2b50" }}
                                            />
                                        </Box>
                                        <Typography variant="body2" style={{ color: "#BEBEBE" }}>Drag & drop or click to choose files</Typography>

                                        <input
                                            type="file"
                                            multiple
                                            onChange={handleSelectFile}
                                            style={{ display: "none" }}
                                        />
                                    </Box>
                                ) : (
                                    /* After Upload: Second Image Style */
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        {/* Left Upload Area */}
                                        <Box
                                            component="label"
                                            sx={{
                                                border: '2px solid transparent',

                                                // Use the borderImageSource with an SVG to create the custom dash pattern.
                                                borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                                borderImageSlice: '1',
                                                minHeight: "127px",
                                                width: "260px", // Fixed width
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#757575",
                                                cursor: "pointer",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    border: "1px solid #ddd",
                                                    borderRadius: 2,
                                                    backgroundColor: "#fff",
                                                    p: 1.5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 1,
                                                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)"
                                                }}
                                            >
                                                <Iconify
                                                    icon="material-symbols:add-notes-outline-rounded"
                                                    width={40}
                                                    height={40}
                                                    style={{ color: "#1a2b50" }}
                                                />
                                            </Box>
                                            <Typography variant="body2" style={{ color: "#BEBEBE" }}>Drag & drop or click to choose files</Typography>

                                            <input
                                                type="file"
                                                multiple
                                                onChange={handleSelectFile}
                                                style={{ display: "none" }}
                                            />
                                        </Box>

                                        {/* Right File List */}
                                        <Stack
                                            spacing={1}
                                            sx={{
                                                width: "545px", // Fixed width
                                                maxHeight: "127px",
                                                overflowY: "auto",
                                            }}
                                        >
                                            {requestFile.map((file, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        border: "1px solid #ddd",
                                                        borderRadius: 1,
                                                        px: 1.5,
                                                        py: 0.5,
                                                        backgroundColor: "#f5f5f5",
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, overflow: "hidden", gap: 0.5 }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                                                            <Icon icon="tabler:file-text" width={18} height={18} style={{ color: "#616161" }} />
                                                        </Box>
                                                        <Typography
                                                            variant="body2"
                                                            noWrap
                                                            title={file.name}
                                                        >
                                                            {file.name}
                                                        </Typography>
                                                    </Box>
                                                    <IconButton
                                                        edge="end"
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            removeFile(index);

                                                        }}
                                                        sx={{
                                                            color: '#FF1744',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(255,23,68,0.1)',
                                                            },
                                                        }}
                                                    >
                                                        <Icon icon="material-symbols:delete-outline" width={20} height={20} />


                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Box>

                                )}
                            </Box>
                        </Box>
                    </Box>
                </Grid>

                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 2,
                        mt: 0.5,
                        pr: 2,
                    }}
                >
                    <Button variant="outlined" color="inherit" onClick={handleReset}>
                        Reset
                    </Button>

                    <LoadingButton
                        size="medium"
                        variant="contained" color='primary' onClick={handleSaveIssueClick} disabled={isSaved} sx={isSaved ? { backgroundColor: "#9A9A9A", color: "#FFFFFF" } : {}}
                        loading={isLoading}
                    >
                        Save
                    </LoadingButton>

                    <Button variant="contained" color='secondary' onClick={handleFillService} disabled={!isSaved} sx={!isSaved ? { backgroundColor: "#9A9A9A", color: "#FFFFFF" } : {}}>
                        Fill service
                    </Button>
                </Box>

            </Grid>

            <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)}>
                <DialogContent sx={{ textAlign: "center", p: 3 }}>
                    {/* Green check circle */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#4caf50",
                            borderRadius: "50%",
                            width: 50,
                            height: 50,
                            mx: "auto",
                            mb: 2,
                        }}
                    >
                        <Icon icon="mdi:check" color="white" width={28} height={28} />
                    </Box>

                    {/* Title */}
                    <Typography variant="h5" gutterBottom>
                        Saved!
                    </Typography>

                    {/* Message */}
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Your issue with ID{" "}
                        <Box component="span" sx={{ color: "error.main", fontWeight: "bold" }}>
                            {savedIssueId || ""}
                        </Box>{" "}
                        has been saved successfully
                    </Typography>

                    {/* Buttons */}
                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                        <Button
                            variant="outlined"
                            sx={{ color: '#2E7D32' }}
                            onClick={() => setOpenSuccess(false)}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCopyId}
                            startIcon={<Icon icon="mdi:content-copy" />}
                        >
                            {copied ? "Copied!" : savedIssueId || ""}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {openModalForSaveIssue && (<ModalPopUp openCloseValue={setOpenModalForSaveIssue} msg="Are you sure you want to save the Issue?" confirm={handleSaveIssueConfirm} />)}

        </>
    );
}
